import React from 'react'

export default function FeedLoading () {
  return (
    <div className="loading">
      <i class="fas fa-sync fa-spin fa-5x"></i>
    </div>
  )
}